import { render, staticRenderFns } from "./zhzfzlist.vue?vue&type=template&id=48f3593f&scoped=true&"
import script from "./zhzfzlist.vue?vue&type=script&lang=js&"
export * from "./zhzfzlist.vue?vue&type=script&lang=js&"
import style0 from "./zhzfzlist.vue?vue&type=style&index=0&id=48f3593f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f3593f",
  null
  
)

export default component.exports